@let availableStates = availableStates$ | async; @let availableCounties = availableCounties$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/property-search"></ion-back-button>
    </ion-buttons>
    <ion-title>Search By Parcel Number</ion-title>
  </ion-toolbar>
</red-header-content>

<red-page-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="555-555-555"
          inputmode="text"
          [required]="true"
          type="text"
          formControlName="parcelNumber"
        >
          <div slot="label">Parcel Number:<ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
    </ion-list>
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-item-divider>
        <ion-label>Address</ion-label>
      </ion-item-divider>
      @if (availableStates) {
      <red-searchable-select
        redErrorMessage
        [redRequired]="true"
        formControlName="state"
        [options]="availableStates"
        placeholder="Select state"
        searchPlaceholder="Search state..."
      >
        <span searchable-select-label class="tw:whitespace-normal">
          State:
          <ion-text color="danger">*</ion-text>
        </span> </red-searchable-select
      >} @if (availableCounties) {
      <red-searchable-select
        redErrorMessage
        [redRequired]="true"
        formControlName="county"
        [options]="availableCounties"
        placeholder="Select county"
        searchPlaceholder="Search county..."
      >
        <span searchable-select-label class="tw:whitespace-normal">
          County:
          <ion-text color="danger">*</ion-text>
        </span>
      </red-searchable-select>
      }
    </ion-list>

    <ion-button class="tw:m-4" expand="block" (click)="onSubmit()" [disabled]="!form.valid || !form.dirty">
      Search<ion-icon slot="start" name="search-outline"></ion-icon>
    </ion-button>
  </form>
</red-page-content>
